// Shared script types + seed data. Client-safe (no server-only imports), so it
// can be imported by both the homepage and the seeding API route.

export interface Script {
  id: number;
  name: string;
  rank: number;
  status: 'Updated' | 'Not Updated' | 'Pending' | 'Discontinued';
  lastUpdated: string;
  features: string[];
  anticurveRating: number;
  anticurveLabel: string;
  description: string;
  platform: 'Windows' | 'Mac' | 'Android' | 'iOS';
  category: 'Blade Ball' | 'Pending' | 'Discontinued';
  free: boolean;
  paid: boolean;
  private?: boolean;
  pending?: boolean;
  keySystem: boolean;
  team?: string;
  backwardDetection?: boolean;
  website?: string;
  discord?: string;
}

export const PENDING_MESSAGE = 'This script is currently pending for ranking';

// Intentionally empty — all scripts are created/managed through the /admin panel.
export const SEED_SCRIPTS: Script[] = [];
